import { fetcher } from "helpers/fetcher";

import { TAddStaffStatusReq, TAddStaffStatusRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addStaffStatus = async (payload: TAddStaffStatusReq) => {
  return await fetcher<TAddStaffStatusRes, TAddStaffStatusReq["data"]>(
    ENDPOINT.CORPORATION.ADD_STAFF_STATUS,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.CORP_ID]: payload.corpId,
      },
    }
  );
};

export const mutationAddStaffStatus = async (payload: TAddStaffStatusReq) => {
  return (await addStaffStatus(payload)).data;
};

mutationAddStaffStatus._key = (payload: TAddStaffStatusReq) => [
  ENDPOINT.CORPORATION.ADD_STAFF_STATUS.url,
  payload,
];
